import Head from "next/head";
import PageLayout from "@/components/PageLayout";
import Paginator from "@/components/paginator";
import DownloadFilters from '@/components/download_filters.js'; 
import { useState, useRef } from "react";
import Qs from "qs";
import ProductService from "@/lib/services/products.js";
import DownloadService from '@/lib/services/downloads.js'; 
import searchTranslator from "@/lib/search_translator.js";
import SearchBuilder from "@/components/search_builder.js";
import ProductAssetsTable from '@/components/product_assets_table.js'; 
import CompanyResourcesTable from '@/components/company_resources_table.js'; 
import DownloadTabs from '@/components/download_tabs.js';  
import Loader from '@/components/loading_animation.js'; 
import { loadConfig } from "@/lib/utils.js";
import AnalyticService from "@/lib/services/analytics";
import Link from "next/link";
import Image from "next/image";

function Downloads(results) {
  const { favicon, stylesheet, page_layout, cart_enabled, slug, resource_display } = results;
  const { company_downloads, products, total_count, initialSearch, collection_filters } = results;
  const {enable_asset_multiple_link_download_modal, enable_asset_multiple_link_copying_modal } = results

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(total_count);
  const [downloads, setDownloads] = useState(products ? products : company_downloads);
  const [currentTab, setCurrentTab] = useState(slug)
  const [filters, setFilters] = useState(collection_filters);

  const searchDownloads = (search) => {
    setIsLoading((currentIsLoaded) => true);
    fetch(
      "/lex-api/downloads/all" +
      "?" +
      Qs.stringify(search, { arrayFormat: "brackets", encode: true })
    )
      .then((res) => res.json())
      .then((data) => {
        setIsLoading((currentIsLoaded) => false);
        setDownloads(data.products);
        setFilters(data.collection_filters); 
        setTotalCount(data.total_count);
      });
  };

   const searchResources = (search) => {
    setIsLoading((currentIsLoaded) => true);
    fetch(
      "/lex-api/downloads/company-resources" +
      "?" +
      Qs.stringify(search, { arrayFormat: "brackets", encode: true })
    )
      .then((res) => res.json())
      .then((data) => {
        setIsLoading((currentIsLoaded) => false);
        setDownloads(data.company_downloads);
        setFilters(data.collection_filters);
        setTotalCount(data.total_count);
      });
  };

  const searchFunction = currentTab == 'company-resources' ? searchResources : searchDownloads;

  const tabChange = async (tab, searchState) => {
    setCurrentTab(tab);
    await new Promise((resolve, reject) => { 
    tab === 'company-resources' ? searchResources({}) : searchDownloads({});
      searchInput.current ? searchInput.current.value = '' : '';
     resolve(); 
    })
  }
  const searchInput = useRef(null);
  return (
    <PageLayout
      favicon={favicon}
      page_layout={page_layout}
      stylesheet={results.stylesheet}
      cart_enabled={cart_enabled}
      title={"Downloads"}
    >
      <SearchBuilder
        initialSearch={initialSearch}
        search={searchFunction}
      >
        {(searchState) => {
          return (
            <section className="lexcms-downloads-page-container">
              <section className="lexcms-downloads-page-header-container">
                <div className="lexcms-downloads-page-body-header-text">
                  <h1 className="lexcms-downloads-page-heading">Downloads</h1>
                  <h3 className="lexcms-downloads-page-subheading">
                    Quickly Discover & Download Product Assets
                  </h3>
                </div>
              </section>
              <DownloadTabs currentTab={currentTab} setCurrentTab={(tab) =>( tabChange(tab, searchState)) } ></DownloadTabs>
              <section className="lexcms-downloads-search-bar-container">
                <DownloadFilters searchState={searchState} 
                                 collection_filters={filters}  
                                 searchFunction={searchFunction}
                                 currentTab={currentTab}
                                 searchInput={searchInput}
                />
              </section>
              <p className="lexcms-downloads-results-count">
                {totalCount} Results Found
              </p>
              {isLoading ? (<Loader />) : (
                <>
              {currentTab === 'product-assets' &&
              <ProductAssetsTable downloads={downloads} config={{enable_asset_multiple_link_copying_modal: enable_asset_multiple_link_copying_modal, enable_asset_multiple_link_download_modal: enable_asset_multiple_link_download_modal }} resource_display={resource_display} /> 
              }
              {currentTab === 'company-resources' &&
                <CompanyResourcesTable downloads={downloads} /> 
              }
              </>
              )
              }
              {totalCount > 40 && (
                <Paginator
                  itemsPerPage={40}
                  pageRangeDisplayed={5}
                  totalCount={totalCount}
                  search={searchState}
                />
              )}
            </section>
          );
        }}
      </SearchBuilder>
    </PageLayout>
  );
}

export async function getServerSideProps(context) {
  let service;
  let token = context.req?.headers['lex-api-token'];
  let slug = context.params.slug?.replace(/\?.*/,''); 
  if (/company-resources/.test(slug)) {
    service =  await DownloadService.build(token, context.req?.headers?.host);
  }
  else {
     service = await ProductService.build(token, context.req?.headers?.host); 
  }
  let q = searchTranslator(context.query || {});
  let apiFriendlyQ = searchTranslator(context.query || {}, true);
  let search = await service.index(apiFriendlyQ, {per_page: 40,  withDownloads: true });
  search.initialSearch = q;
  try {
    let analyticService = new AnalyticService(token, {}, true);
    let data = {
      downloads_query: q,
      category: slug
    }
    analyticService.recordDownloadsPageVisited(data, context.req?.headers);
  } 
  catch (e) {
    console.log(e);
  }
  let pageLayout = loadConfig(service);

  return {
    props: { ...search, ...pageLayout, ...{slug: slug}},
  };
}

export default Downloads;
